export default {
	"AddressItem.edit": "edit"
}